module.exports = __webpack_public_path__ + "static/media/scale_labs.25f6d93b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/scale_labs.jpg
// module id = 31
// module chunks = 0